module.exports = __webpack_public_path__ + "img/search-input-hen.a9dcbbca.png";